<template>
  <div class="contentful-container contentful-container-restricted" :class="{narrow: data.smallContainer}">
    <suspense>
      <ContentfulRichText
        v-if="data"
        :page-style="data.pageStyle"
        :content="data.content"
        :spacing-rule="data.spacingRule"
        :typography-rule="data.typeRule"
      />
    </suspense>
  </div>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Breadcrumb.vue';
import ContentfulRichText from '@/components/contentful/Fields/ContentfulRichText.vue';
import { useContentful, contentfulProps } from '@/compositions/useContentful.js';

export default {
  name: 'ContentPage',
  components: {
    ContentfulRichText,
    Breadcrumb,
  },
  props: contentfulProps,
  async setup(props, ctx) {
    const { data, init } = useContentful('campaignPage', props, ctx);

    await init();

    return {
      data,
    };
  },
};
</script>